import {
  FIELDTYPE_TITLE,
  FIELDTYPE_SUMMARY,
  HEARINGROLE_OWNER,
  FIELDTYPE_IMAGE,
  CONTENTTYPE_TEXT,
  CONTENTTYPE_FILE,
} from '../constants/api';
import { getAttr, getEntityId, getRelId } from '../features/helpers/apiHelpers';
import {
  formatDateForRender,
  formatDateWithTimestampForRender,
} from '../features/helpers/dateHelpers';
import { mapContentDownloadUrl } from './mapperFunctions';

export const getContentOfTypeFromHearing = (
  hearing,
  contents,
  fieldTypes,
  fields,
  type,
) => {
  const contentsForHearing =
    contents &&
    contents.filter((c) => getRelId(c, 'hearing') === getEntityId(hearing));

  // Find the fieldType entity that represents the given type
  const fieldType =
    fieldTypes && fieldTypes.find((fT) => getAttr(fT, 'fieldType') === type);

  // Find field that is linked to the current hearing (via content) with the given type
  const field =
    fields &&
    fields.find(
      (f) =>
        getRelId(f, 'fieldType') === getEntityId(fieldType) &&
        contentsForHearing.some(
          (content) => getRelId(content, 'field') === getEntityId(f),
        ),
    );

  // Find the content that is linked to the hearing for the given field type
  return (
    contentsForHearing &&
    contentsForHearing.filter(
      (c) => getRelId(c, 'field') === getEntityId(field),
    )
  );
};

export const getHearingOwner = (
  hearing,
  hearingRoles,
  userHearingRoles,
  users,
) => {
  const hearingRoleOwner =
    hearingRoles &&
    hearingRoles.find((r) => getAttr(r, 'role') === HEARINGROLE_OWNER);

  const userHearingRoleOwner =
    userHearingRoles &&
    userHearingRoles
      .filter(
        (uhr) => getRelId(uhr, 'hearingRole') === getEntityId(hearingRoleOwner),
      )
      .find((uhr) => getRelId(uhr, 'hearing') === getEntityId(hearing));

  return users.find(
    (u) => getRelId(userHearingRoleOwner, 'user') === getEntityId(u),
  );
};

export const mapHearingItem = (
  hearing,
  subjectAreas,
  cityAreas,
  hearingTypes,
  hearingStatuses,
  fieldTypes,
  fields,
  contents,
  users,
  userHearingRoles,
  hearingRoles,
  baseApiUrl,
  contentTypes,
  defaultHearingTitle,
) => {
  const subjectArea =
    subjectAreas &&
    subjectAreas.find(
      (sA) => getEntityId(sA) === getRelId(hearing, 'subjectArea'),
    );

  const cityArea =
    cityAreas &&
    cityAreas.find((cA) => getEntityId(cA) === getRelId(hearing, 'cityArea'));

  const hearingStatus =
    hearingStatuses &&
    hearingStatuses.find(
      (hS) => getEntityId(hS) === getRelId(hearing, 'hearingStatus'),
    );

  const hearingType =
    hearingTypes &&
    hearingTypes.find(
      (hT) => getEntityId(hT) === getRelId(hearing, 'hearingType'),
    );

  const [titleContent] = getContentOfTypeFromHearing(
    hearing,
    contents,
    fieldTypes,
    fields,
    FIELDTYPE_TITLE,
  );
  const [summaryContent] = getContentOfTypeFromHearing(
    hearing,
    contents,
    fieldTypes,
    fields,
    FIELDTYPE_SUMMARY,
  );

  const frontImageContents = getContentOfTypeFromHearing(
    hearing,
    contents,
    fieldTypes,
    fields,
    FIELDTYPE_IMAGE,
  );

  const contentTypeText = contentTypes.find(
    (contentType) => getAttr(contentType, 'contentType') === CONTENTTYPE_TEXT,
  );
  const contentTypeFile = contentTypes.find(
    (contentType) => getAttr(contentType, 'contentType') === CONTENTTYPE_FILE,
  );

  const frontImageFile = frontImageContents.find(
    (content) =>
      getRelId(content, 'contentType') === getEntityId(contentTypeFile),
  );
  const frontImageText = frontImageContents.find(
    (content) =>
      getRelId(content, 'contentType') === getEntityId(contentTypeText),
  );

  const commentAmount = getAttr(hearing, 'commentAmount');

  const hearingOwner = getHearingOwner(
    hearing,
    hearingRoles,
    userHearingRoles,
    users,
  );
  return {
    title:
      getAttr(titleContent, 'textContent') ||
      `${defaultHearingTitle} - ${formatDateWithTimestampForRender(
        getAttr(hearing, 'created'),
      )}`,
    summary: getAttr(summaryContent, 'textContent') || '-',
    startDate: getAttr(hearing, 'startDate')
      ? formatDateForRender(getAttr(hearing, 'startDate'))
      : '-',
    deadline: getAttr(hearing, 'deadline')
      ? formatDateForRender(getAttr(hearing, 'deadline'))
      : '-',
    imageUrl:
      getEntityId(frontImageFile) &&
      mapContentDownloadUrl(getEntityId(frontImageFile), baseApiUrl),
    imageAltText: getAttr(frontImageText, 'textContent'),
    key: getEntityId(hearing),
    subjectArea: getAttr(subjectArea, 'name') || '-',
    cityArea: getAttr(cityArea, 'name') || '-',
    hearingStatus: getAttr(hearingStatus, 'status'),
    hearingType: getAttr(hearingType, 'name') || '-',
    esdhNumber: getAttr(hearing, 'esdhNumber') || '-',
    hearingOwner: getAttr(hearingOwner, 'employeeDisplayName') || '-',
    responses: commentAmount || 0,
  };
};
